<template>
  <div id="products">
    <section class=" " :class="!fromUser ? 'pt-20 md:pt-10' : ''">
      <div class="w-full max-w-screen-xl mx-auto px-4 sm:px-6 md:px-8 lg:px-16">
        <div
          class="flex h-full flex-col md:flex-row gap-5 md:gap-5 lg:gap-10 items-center lg:items-stretch justify-center"
        >
          <ProductPrice
            v-for="(product, index) in productsWithDetails"
            ref="productPrice"
            :key="product.id"
            :keyRef="index"
            :product="product"
            :paddleId="paddleId"
            :currPlan="currPlan"
            :needBillingAddressForm="needBillingAddressForm"
            @refreshPlans="getCurrentPlan"
            @setCurrentPlan="setCurrentPlan"
            @showBillingAddressPopup="showBillingAddressPopup"
            @showForm="showModalFormTalkToUs"
          />
        </div>

        <modalForm :show="showFormTalkToUs" @closeModal="closeModalTalkToUs">
          <FormTalkToUs
            @closeModalTalkToUs="closeModalTalkToUs"
            :errors="errors"
          />
        </modalForm>
      </div>
    </section>
  </div>
</template>

<script>
import ProductPrice from "../Pricing/productPrice.vue";
import modalForm from "../../modal.vue";
import billingAddress from "../../../Pages/User/BillingAddress.vue";
import FormTalkToUs from "./FormTalkToUs.vue";
export default {
  components: {
    ProductPrice,
    modalForm,
    billingAddress,
    FormTalkToUs,
  },
  props: ["fromUser", "errors"],
  data() {
    return {
      billing: "monthly",
      products: [],
      paddleId: null,
      currPlan: null,
      needBillingAddressForm: false,
      showFormModal: false,
      planIdSelectedForm: null,
      loadingPlans: true,
      loadingPlan: true,
      showFormTalkToUs: false,
      details: [
        {
          id: 1,
          private_name: "face",
          title: "Includes:",
          target:
            "Businesses integrating high-accuracy face matching into identity workflows.",
        },
        {
          id: 2,
          private_name: "web",
          title: "All Face Matching features plus:",
          target: "Businesses needing privacy-first customer authentication.",
        },
        {
          id: 6,
          private_name: "kyc",
          title: "All Face Authentication features plus:",
          target:
            "Businesses verifying customer IDs and enabling re-authentication.",
        },
      ],
    };
  },
  created() {
    this.getCurrentPlan();

    this.axios
      .get("/get-plans")
      .then((response) => {
        this.products = response.data.products;
        this.paddleId = response.data.paddle_id;
        this.loadingPlans = false;
      })
      .catch(() => {
        this.loadingPlans = false;
      });

    if (this.$page.props.auth.user != null) {
      this.axios.get("/user/api/billing-address").then((response) => {
        if (response.data) {
          if (response.data.billingAddress == null) {
            this.needBillingAddressForm = true;
          }
        }
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (window.location.href.search("#products") >= 0) this.goToProducts();
    });
  },
  computed: {
    productsWithDetails() {
      return this.products.map((product) => {
        const detail = this.details.find(
          (d) => d.private_name === product.private_name
        );
        return { ...product, details: detail ? { ...detail } : null };
      });
    },
  },

  methods: {
    closeModalTalkToUs() {
      this.showFormTalkToUs = false;
    },
    showModalFormTalkToUs() {
      this.showFormTalkToUs = true;
    },
    getCurrentPlan() {
      if (this.$page.props.auth.user != null) {
        this.axios
          .get("/user/api/plan")
          .then((response) => {
            if (response.data.plan_id) {
              this.currPlan = response.data;
            }
            this.loadingPlan = false;
          })
          .catch(() => {
            this.loadingPlan = false;
          });
      }
      this.loadingPlan = false;
    },
    setCurrentPlan(plan_id) {
      this.currPlan = {};
      this.currPlan.plan_id = plan_id;
    },
    showBillingAddressPopup(keyRef) {
      this.planIdSelectedForm = keyRef;
      this.showFormModal = true;
    },
    billingSaved() {
      this.needBillingAddressForm = false;
      this.showFormModal = false;
      this.$refs.productPrice[this.planIdSelectedForm].openPaddlePopup();
    },
    goToProducts() {
      document.getElementById("products").scrollIntoView();
    },
  },
};
</script>
 
